<template>
  <div>
    <a-modal
      :title="title"
      :visible="visible"
      :width="700"
      @ok="handleOk"
      @cancel="handleCancel"
      okText="确认"
      cancelText="取消"
    >
      <div class="wrap">
        <a-card style="width: 100%">
          <div>
            <a-input-search
              v-model="inputQuery"
              placeholder="请输入搜索内容"
              style="width: 200px; margin-bottom: 20px"
              @search="onSearch"
              enterButton
            />
            <a-table
              ref="table"
              size="default"
              :filterMultiple="false"
              :rowKey="(item) => item.id"
              :columns="columns"
              :dataSource="list"
              :rowSelection="rowSelection"
              :scroll="{ y: 300 }"
              @change="handleTableChange"
              :pagination="pagination"
              :loading="loading"
            >
              <!-- <span slot="name" slot-scope="val">
                <p style="display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden">
                  {{ val }}
                </p>
              </span> -->
            </a-table>
          </div>
        </a-card>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { STable } from '@/components'

export default {
  name: 'TheFormOrg',
  components: {
    STable,
  },
  props: {
    matType: {
      type: String,
      default: 'radio',
    },
    url: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default: () => {
        return []
      }
    },
    outerParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    searchName: {
      type: String,
      default: () => {
        return ''
      }
    },
    title: {
      type: String,
      default: '选择'
    }
  },
  data() {
    return {
      visible: false,
      inputQuery: '',
      // columns: [
      //   {
      //     title: '校区名称',
      //     dataIndex: 'orgName',
      //   },
      //   {
      //     title: '机构编码',
      //     dataIndex: 'ocode',
      //   },
      // ],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20'],
      },
      loading: true,
      list: [],
      queryParam: {
        page: 1,
        size: 10,
      },
      productId: '',
      selectedRows: [],
      radioSelectRows: [],
      selectKeys: [],
    }
  },
  watch: {
    outerParams: {
     handler(val) {
       return val
     },
     deep: true
    }
  },
  computed: {
    rowSelection() {
      return {
        type: this.matType,
        onChange: this.onChangeVal,
        selectedRowKeys: this.selectKeys,
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.name === 'Disabled User',
            name: record.name,
          },
        }),
      }
    },
  },
  methods: {
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.queryParam.page = pagination.current
      this.queryParam.size = pagination.pageSize
      this.getList()
    },

    onChangeVal(selectedRowKeys, selectedRows) {
      this.selectKeys = selectedRowKeys
      // this.productId = selectedRowKeys
      if (this.matType === 'radio') {
        this.radioSelectRows = []
      }

      this.radioSelectRows = selectedRows
    },

    // 显示/隐藏
    show() {
      this.visible = true
      this.getList()
    },
    // 提交
    handleOk() {
      this.visible = false
      this.selectedRows = this.radioSelectRows

      this.$emit('select', this.selectedRows)
      // 初始化
      this.handleCancel()
    },

    // 关闭
    handleCancel() {
      this.visible = false
      // 初始化
      this.productId = ''
      this.selectedRows = []
      // this.queryParam.inputQuery = ''
      this.inputQuery = ''
      this.queryParam.size = 10
      this.queryParam.page = 1
      this.pagination = {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20'],
      }

      this.selectKeys = []
      this.radioSelectRows = []
      // this.$forceUpdate()
    },

    async getList() {
      this.loading = true
      const params = {
        [this.searchName]: this.inputQuery,
        current: this.queryParam.page,
        size: this.queryParam.size,
        ...this.outerParams
      }
      const res = await this.$http.get(this.url, { params })
      this.list = res.records
      this.pagination.pageSize = res.size
      this.pagination.total = res.total
      this.loading = false
      this.$forceUpdate()
    },

    onSearch() {
      this.getList()
    },
  },
}
</script>

<style lang="stylus" scoped>
.thumbnail {
  width: 50px;
  height: 50px;
}

.wrap {
  display: flex;
}

.header {
  width: 100%;
  height: 50px;
  // opacity :0.5;
  border-radius: 5px;
  margin-bottom: 10px;
}

.content {
  width: 100%;
  height: 320px;
  border: 1px solid rgb(224, 224, 224);
  border-radius: 5px;
  padding: 20px;
  overflow: auto;
}

.content-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
